import apiAxios from '../../services/axios/axiosConfig';

async function logout() {
  const response = await apiAxios.get<null>('/api/v1/logout', {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
}

export default logout;
